import {
    RETRIEVE_PROMO_CODES,
    CREATE_PROMO_CODE,
    UPDATE_PROMO_CODE,
    DELETE_PROMO_CODE,
    RESTORE_PROMO_CODE,
    UPDATE_PROMO_CODE_STATUS,
} from "../actions/types";
  
const initialState = { promoCodes : [], totalStorageCount : 0 };

const promoCodeReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_PROMO_CODES:
      return {
        promoCodes: payload.rows,
        totalStorageCount: payload.count,
      };

    case CREATE_PROMO_CODE:
      return payload;

    case UPDATE_PROMO_CODE:
      return payload;

    case UPDATE_PROMO_CODE_STATUS:
      return {
        promoCodes: payload.rows,
        totalStorageCount: payload.count,
      };

    case DELETE_PROMO_CODE:
      return {
        promoCodes: payload.rows,
        totalStorageCount: payload.count,
      };

    case RESTORE_PROMO_CODE:
      return {
        promoCodes: payload.rows,
        totalStorageCount: payload.count,
      };

    default:
      return state;
  }
};

export default promoCodeReducer;